import { Logger } from './base';
import { stringifyError } from '@shared/utils/errorUtils';
export var ClientLogsCollection = /*#__PURE__*/ function(ClientLogsCollection) {
    ClientLogsCollection["Telemetry"] = "Telemetry";
    ClientLogsCollection["Feedback"] = "Feedback";
    return ClientLogsCollection;
}({});
export class ClientLoggerTelemetry extends Logger {
    info({ error, collection = "Telemetry", action = '', actionModifier = '', details = '', appName = '', page = '', product = '-1' }) {
        this.log('Info', collection, {
            details,
            appName,
            product,
            page,
            error: error ? stringifyError(error) : '',
            action,
            actionModifier
        });
    }
    debug({ error, collection = "Telemetry", action = '', actionModifier = '', details = '', appName = '', page = '', product = '-1' }) {
        this.log('Debug', collection, {
            details,
            appName,
            product,
            page,
            error: error ? stringifyError(error) : '',
            action,
            actionModifier
        });
    }
    warning({ error, collection = "Telemetry", action = '', actionModifier = '', details = '', appName = '', page = '', product = '-1' }) {
        this.log('Warn', collection, {
            details,
            appName,
            product,
            page,
            error: error ? stringifyError(error) : '',
            action,
            actionModifier
        });
    }
    error({ error, collection = "Telemetry", action = '', actionModifier = '', details = '', appName = '', page = '', product = '-1' }) {
        this.log('Error', collection, {
            details,
            appName,
            product,
            page,
            error: error ? stringifyError(error) : '',
            action,
            actionModifier
        });
    }
}
